import theme from '@css/theme';
import styled from 'styled-components';
import { Body, Subtext } from '@ui-library/typography';

export const Description = styled(Body)`
  margin: 8px 0 24px 0;
  color: ${theme.color.neutral2} !important;
  line-height: 1.25;
`;
export const Link = styled.span`
  color: ${theme.color.rsPrimary} !important;
  cursor: pointer;
`;
export const CodeSnippet = styled.pre`
  font-family: 'Noto Sans';
  background: #f2f7fe;
  border-radius: 4px;
  padding: 16px;
  color: ${theme.color.neutral2};
`;
export const LineBreaker = styled.div`
  border-top: 1px solid ${theme.color.border};
  margin: 24px 0;
`;
export const InfoContainer = styled.div`
  background: ${theme.color.background1};
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
`;
export const InfoMessage = styled(Subtext)`
  color: ${theme.color.neutral3} !important;
`;
